module.exports = __webpack_public_path__ + "img/icon-stress-management.ee3e08c7.png";